import React, { useEffect, useState } from 'react';
import HeaderCard from '../../../components/Header/HeaderCard';
import TableList from '../../../components/Tools/TableList';
import { apiService } from '../../../components/Config/api.service';
import AbsenceForm from './AbsenceForm';
import Drawer from '../../../components/Tools/DrawerCustom';
import AbsenceType from './AbsenceType';
const Absence = () => {
    const [data, setData] = useState([]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isAbsenceTypeDrawerOpen, setIsAbsenceTypeDrawerOpen] = useState(false); 
    // const [drawerAnimating, setDrawerAnimating] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterBy, setFilterBy] = useState('');
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
            offset: 0,
            limit: 25,
            total_pages: 1,
            total_count: 0
        });

    const handleRowClick = (id) => {
        setSelectedId(id);
        openDrawer();
    };

    const openDrawer = () => {
        // setDrawerAnimating(true);
        setIsDrawerOpen(true);
    };

    // const closeDrawer = () => {
    //     setDrawerAnimating(true);
    //     setIsDrawerOpen(false);
    //     setTimeout(() => {
    //         setDrawerAnimating(false);
    //     }, 300);
    // };

    

    const columns = [
        { key: 'employee_name', label: 'Employé' },
        { key: 'date', label: 'Date début' },
        { key: 'date_end', label: 'Date fin' },
        { 
            key: 'absenceTypeCategory', 
            label: 'Type',
            render: (value) => {
                let badgeClass = '';
                let badgeLabel = '';

                switch (value.absenceTypeCategory) {
                    case 'deducted':
                        // Utilisation d'une teinte orange douce cohérente avec la palette
                        badgeClass = 'bg-orange-100 text-orange-800 border border-orange-200';
                        badgeLabel = 'Déduites';
                        break;
                    case 'paid':
                        // Utilisation d'une teinte verte douce et élégante
                        badgeClass = 'bg-emerald-100 text-emerald-800 border border-emerald-200';
                        badgeLabel = 'Payées';
                        break;
                    default:
                        // Utilisation d'une teinte de la couleur primaire pour la cohérence
                        badgeClass = 'bg-slate-100 text-slate-700 border border-slate-200';
                        badgeLabel = 'Non Payées';
                        break;
                }

                return (
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${badgeClass}`}>
                        {badgeLabel}
                    </span>
                );
            }
        },
    ];

    const getAbsences = (page = 1, search = '', filter = '') => {
        setLoading(true);
        const offset = (page - 1) * pagination.limit;
        const params = new URLSearchParams();
        params.append('offset', offset);
        params.append('limit', pagination.limit);
        if (search) {
            params.append('search', search);
        }
        if (filter) {
            params.append('filter_by', JSON.stringify(filter));
        }
        apiService.getElement(`/absences?${params.toString()}`)
            .then(response => {
                setData(response.data.absences);
                const responseData = response.data;
                if (responseData.pagination) {
                    const currentPage = Math.floor(responseData.pagination.offset / responseData.pagination.limit) + 1;

                    setPagination({
                        ...responseData.pagination,
                        page: currentPage
                    });
                }
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
                setData([]);
                setPagination({
                    offset: 0,
                    limit: 4,
                    total_pages: 1,
                    total_count: 0
                });
            });
        setLoading(false);
    }

    useEffect(() => {
        getAbsences(pagination.page, searchTerm, filterBy);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlePageChange = (page, search, filter) => {
        const newSearchTerm = search !== undefined ? search : searchTerm;
        const newFilterBy = filter !== undefined ? filter : filterBy;
        
        setSearchTerm(newSearchTerm);
        setFilterBy(newFilterBy);
        
        getAbsences(page, newSearchTerm, newFilterBy);
    };

    const refreshAbsenceList = () => getAbsences()


    return (
        <div className="p-6">
            <div className='flex justify-between items-center mb-6'>
                <HeaderCard 
                    title="Absences et Congés"
                    exportProps={{
                        model_name: "absence",
                        fields: ["employee_id", "absence_type_id", "date", "date_end", "hours", "description"],
                        filename: "absences_export",
                        importUrl: "/import/absence",
                        onImportSuccess: refreshAbsenceList
                    }} 
                />

                <div className="flex justify-between items-center gap-2">
                    <button
                        className="btn btn-md bg-gray-500 text-white rounded-full"
                        onClick={() => setIsAbsenceTypeDrawerOpen(true)} 
                    >
                        Gérer les Types d'absence
                    </button>
                    <button
                        className="btn btn-md bg-[--color-primary] text-white rounded-full mr-2"
                        onClick={() => { setSelectedId(null); openDrawer(); }}
                    >
                        Ajouter une Absence
                    </button>
                    
                </div>
            </div>

            <div className="overflow-x-auto card bg-white shadow-sm rounded-lg p-2">
                <TableList
                    columns={columns}
                    data={data}
                    pagination={pagination}
                    onPageChange={handlePageChange}
                    searchQuery={searchTerm}
                    setSearchQuery={setSearchTerm}
                    // filterBy={filterBy}
                    // setFilterBy={setFilterBy}
                    showFilter={false}
                    model={'absence'}
                    onRowClick={row => handleRowClick(row.id)} 
                    loading={loading}
                />
            </div>

            <div className={`fixed inset-0 z-50 ${isDrawerOpen ? 'pointer-events-auto' : 'pointer-events-none'}`}>
            <Drawer isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen} width={600}>
                
                <AbsenceForm
                setIsDrawerOpen={setIsDrawerOpen}
                id={selectedId}
                refreshAbsenceList={refreshAbsenceList}
                />
            </Drawer>
            </div>
            <div className={`fixed inset-0 z-50 ${isAbsenceTypeDrawerOpen ? 'pointer-events-auto' : 'pointer-events-none'}`}>
                <Drawer isOpen={isAbsenceTypeDrawerOpen} setIsOpen={setIsAbsenceTypeDrawerOpen}>
                    <AbsenceType
                        setIsDrawerOpen={setIsAbsenceTypeDrawerOpen}
                        refreshParent={refreshAbsenceList}
                    />
                </Drawer>
            </div>
        </div>
    );
};

export default Absence;